import * as React from "react";
const SvgBusinessInformation = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "business_information_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "business_information_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M0 0h24v24H0z",
	style: { fill: "none" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M9 5.5h6V6H9zM12 11v3M12 8v2",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("path", {
	d: "M17 4.5V2.6A2.1 2.1 0 0 0 14.9.5H9.1A2.1 2.1 0 0 0 7 2.6v1.9H2.65A1.65 1.65 0 0 0 1 6.15v8.34a1.65 1.65 0 0 0 1.5 1.65v5.21A1.65 1.65 0 0 0 4.15 23h16.2A1.65 1.65 0 0 0 22 21.35v-5.26l1-.09V6.15a1.65 1.65 0 0 0-1.65-1.65Zm-8-2h6v2H9ZM3 9.75V6.5h18v7.67L12 15l-9-.82ZM20 21H4.5v-4.68L12 17l8-.73Z",
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("rect", {
	width: 2,
	height: 3,
	x: 11,
	y: 11,
	rx: 1,
	style: { fill: "currentColor" }
}), /* @__PURE__ */ React.createElement("rect", {
	width: 2,
	height: 2,
	x: 11,
	y: 8,
	rx: 1,
	style: { fill: "currentColor" }
}))));
export default SvgBusinessInformation;
